<template>
  <el-container v-title data-title="读卡查询" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>学校活动</el-breadcrumb-item>
                <el-breadcrumb-item>体温填报</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form ref="searchForm" :inline="true" :model="searchForm" :rules="rules" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="日期" :required="true" prop="date">
                  <el-date-picker
                    v-model="searchForm.date"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyyMMdd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getBodyTemperatureCollectionStatsList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="className" label="班级名称" width="160"></el-table-column>
          <el-table-column prop="studentCount" label="学生人数" width="160"></el-table-column>
          <el-table-column label="正常人数" width="160">
            <template slot-scope="scope">
              <el-button type="text" @click="getBodyTemperatureCollectionStatsDetail(scope.row.classId, 1)">{{ scope.row.normalCount }}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="异常人数" width="160">
            <template slot-scope="scope">
              <el-button type="text" @click="getBodyTemperatureCollectionStatsDetail(scope.row.classId, 0)">{{ scope.row.abnormalCount }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-dialog
        title="体温填报明细"
        :visible.sync="detailListDialogVisible"
        width="900px"
        :before-close="handleClose">
        <el-table :data="detailListTableData" border stripe>
          <el-table-column prop="studentName" label="学生姓名" width="120"></el-table-column>
          <el-table-column prop="value1" label="昨晚体温" width="120"></el-table-column>
          <el-table-column prop="value2" label="今晨体温" width="120"></el-table-column>
          <el-table-column prop="value3" label="身体状态" width="120"></el-table-column>
          <el-table-column prop="value4" label="异常情况" width="320"></el-table-column>
        </el-table>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      total: 0,
      searchForm: {
        schoolId: null,
        date: new Date().toISOString().slice(0, 10).replace(/-/g, '')
      },
      rules: {
        schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
        date: [{ required: true, message: '请选择日期', trigger: 'blur' }]
      },
      tableData: [],
      detailListDialogVisible: false,
      detailListTableData: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getBodyTemperatureCollectionStatsList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getBodyTemperatureCollectionStatsList () {
      let _this = this
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          _this.loading = true
          this.$axios.post(this.GLOBAL.host + '/bodyTemperatureCollection/getStatsList',
            this.$qs.stringify({
              schoolId: _this.searchForm.schoolId,
              searchDate: _this.searchForm.date
            })
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.tableData = res.data.data
              } else {
                this.$message.error(res.data.message)
              }
            }
            _this.loading = false
          })
        }
      })
    },
    getBodyTemperatureCollectionStatsDetail (classId, status) {
      let _this = this
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          _this.loading = true
          this.$axios.post(this.GLOBAL.host + '/bodyTemperatureCollection/getStatsDetail',
            this.$qs.stringify({
              searchDate: _this.searchForm.date,
              classId: classId,
              status: status
            })
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.detailListDialogVisible = true
                _this.detailListTableData = res.data.data
              } else {
                this.$message.error(res.data.message)
              }
            }
            _this.loading = false
          })
        }
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/BodyTemperatureCollection.vue